/* MV Sortiment assets/mv-sortiment.a8.js - Paket A-8 - 2026-10-14 */
/*
 * Rueckweg und Werkzeug-Raster der Kontoseite "Meine Werkzeuge" (Paket A-8, _docs/a8-konto-rueckweg.md). Inhaber
 * 14.10.2026: "Wenn ich auf Meine Werkzeuge gehe ist es unklar wie ich zurueck auf die Seite komme wo ich her komme" und
 * zur leeren Seite "Das hier sollte prominenter mit Buttons und so die Zielseiten zeigen". Markup und alle Texte in
 * sections/mv-konto-werkzeuge.liquid (Paket A-3, Nachtrag A-8), Gestaltung assets/mv-sortiment.a8.css.
 *
 * Rueckweg [data-mv-a8-rueck] im Seitenkopf:
 *   Ausgangsseite = document.referrer, wenn gleiche Herkunft, nicht diese Seite selbst und keine Anmelde- oder
 *   Kontoseite; sonst der Parameter ?von=<pfad> dieser Seite (die Links "Meine Werkzeuge" und "Was wird gespeichert?"
 *   in snippets/mv-konto-hinweis.liquid geben ihn mit); sonst die zuletzt in diesem Tab erkannte Ausgangsseite
 *   (sessionStorage mv-konto:rueckweg, nur ein Pfad - so fuehrt der Link auch nach dem Umweg ueber die Anmeldung oder
 *   die gehosteten Kontoseiten zurueck); sonst bleibt der Link aus Liquid ("Zur Akademie").
 *   Text: Name aus dem Verzeichnis der Seite (template[data-mv-kontoseite-werkzeug|praefix] von Paket A-3 und die
 *   Karten des Rasters mit einer Seite /pages/ als Ziel, etwa die Akademie-Uebersicht) in der Vorlage
 *   [data-mv-a8-vorlage="zurueck"]; unbekannte Seiten (auch Kollektionen) mit [data-mv-a8-vorlage="vorherige"]. Pfade nur dieser Herkunft (Pfad und Suchteil, kein Schema, kein Host, kein //), hoechstens 300
 *   Zeichen.
 *   "Zum Kundenkonto" ([data-mv-a8-konto], nur mit Login aus Liquid) verschwindet, wenn die Seite in den Zustand gast
 *   wechselt (401).
 * Raster [data-mv-a8-werkzeuge] im Band "konto": in den Zustaenden laedt, leer und fehler alle Karten, im Zustand liste
 *   nur die Werkzeuge ohne gespeicherten Stand (Eintraege [data-mv-kontoseite-eintrag] mit genau ihrem Schluessel;
 *   Akademie und Konfigurator bleiben, sie speichern je Lernpfad bzw. je Automat) und die Ueberschrift "Weitere
 *   Werkzeuge". Folgt dem Ereignis "mv-kontoseite:zustand" von assets/mv-sortiment.konto-seite.js (Paket A-3) und den
 *   Aenderungen der Liste (Loeschen einer Karte). Sind alle Karten verborgen, verschwindet das Raster.
 * Keine Kunden-ID, kein fetch, kein localStorage; sessionStorage nur fuer den einen Pfad (jeder Zugriff in try/catch).
 * Teil von assets/mv-sortiment.js (_build/konkat.sh, Byte-Reihenfolge vor akademie.js und konto-seite.js); Start per
 * Mikrotask nach dem ganzen Buendel, vor dem Start der Kontoseite. Unter Node (Tests) liefert die Datei die reinen
 * Funktionen. Kommentare und Datei ASCII.
 */
;(function () {
  'use strict';

  var VERSION = '2026-10-14.1';
  var SPEICHER = 'mv-konto:rueckweg';
  var LAENGE = 300;
  var SICHER_RE = /^\/(?!\/)[A-Za-z0-9\-._~\/%]*(\?[A-Za-z0-9\-._~%=&+,]*)?$/;
  var GESPERRT_RE = /^\/(customer_authentication|account|checkouts?|cart)(\/|$)/;

  // ===========================================================================================
  // Teil 1: reine Logik (ohne DOM)
  // ===========================================================================================

  /** Pfad ohne abschliessenden Schraegstrich (ausser "/"), fuer Vergleiche. */
  function normal(pfad) {
    var p = String(pfad || '');
    return p.length > 1 ? p.replace(/\/+$/, '') : p;
  }

  /** Pfad und Suchteil einer Adresse derselben Herkunft (sonst ''). adresse: absolute oder relative Adresse;
   *  herkunft: location.origin; hier: Pfad dieser Seite (ausgeschlossen). Nie Anmelde-, Konto-, Kassen- oder
   *  Warenkorbseiten, nie Adressen mit Schema, Host oder //. */
  function ortVon(adresse, herkunft, hier) {
    var a = String(adresse || '');
    if (!a || a.length > 2000) return '';
    var pfad = '';
    var suche = '';
    if (a.charAt(0) === '/') {
      if (a.charAt(1) === '/' || a.charAt(1) === '\\') return '';
      var h = a.indexOf('#');
      if (h >= 0) a = a.slice(0, h);
      var q = a.indexOf('?');
      pfad = q >= 0 ? a.slice(0, q) : a;
      suche = q >= 0 ? a.slice(q) : '';
    } else {
      var o = String(herkunft || '');
      if (!o || a.indexOf(o + '/') !== 0) return '';
      return ortVon(a.slice(o.length), herkunft, hier);
    }
    if (suche === '?') suche = '';
    var ort = pfad + suche;
    if (ort.length > LAENGE || !SICHER_RE.test(ort)) return '';
    if (GESPERRT_RE.test(pfad)) return '';
    if (hier && normal(pfad) === normal(hier)) return '';
    return ort;
  }

  /** Pfad aus dem Parameter von der Suchzeile dieser Seite (url-kodiert; sonst ''). */
  function vonParameter(suche) {
    var s = String(suche || '');
    if (s.charAt(0) === '?') s = s.slice(1);
    var teile = s ? s.split('&') : [];
    for (var i = 0; i < teile.length; i++) {
      var kv = teile[i].split('=');
      if (kv[0] !== 'von' || kv.length !== 2) continue;
      try {
        return decodeURIComponent(kv[1].replace(/\+/g, ' '));
      } catch (e) {
        return '';
      }
    }
    return '';
  }

  /** Ausgangsseite: { ort, quelle } mit quelle 'referrer' | 'von' | 'gemerkt' | '' (dann ort ''). */
  function ausgangsseite(e) {
    var hier = e && e.hier;
    var herkunft = e && e.herkunft;
    var r = ortVon(e && e.referrer, herkunft, hier);
    if (r) return { ort: r, quelle: 'referrer' };
    var v = ortVon(vonParameter(e && e.suche), herkunft, hier);
    if (v) return { ort: v, quelle: 'von' };
    var g = ortVon(e && e.gemerkt, herkunft, hier);
    if (g) return { ort: g, quelle: 'gemerkt' };
    return { ort: '', quelle: '' };
  }

  /** Name einer Seite aus dem Verzeichnis: genaue Pfade zuerst, dann Praefixe (laengstes zuerst); sonst ''. */
  function nameVon(ort, verzeichnis) {
    var pfad = normal(String(ort || '').split('?')[0]);
    var v = verzeichnis || {};
    var genau = v.genau || [];
    for (var i = 0; i < genau.length; i++) if (normal(genau[i].pfad) === pfad) return genau[i].name;
    var praefixe = (v.praefixe || []).slice().sort(function (a, b) { return b.pfad.length - a.pfad.length; });
    for (var j = 0; j < praefixe.length; j++) {
      var p = praefixe[j].pfad;
      if (p && pfad.indexOf(p) === 0 && pfad.length > p.length) return praefixe[j].name;
    }
    return '';
  }

  /** Verborgene Karten im Zustand liste: Schluessel mit genau diesem Eintrag (Praefix-Karten nie). */
  function verborgen(karten, eintraege, zustand) {
    var aus = {};
    if (zustand !== 'liste') return aus;
    var da = {};
    for (var i = 0; i < (eintraege || []).length; i++) da[eintraege[i]] = true;
    for (var j = 0; j < (karten || []).length; j++) {
      var k = karten[j];
      if (!k.praefix && da[k.schluessel]) aus[k.schluessel] = true;
    }
    return aus;
  }

  var logik = { VERSION: VERSION, SPEICHER: SPEICHER, normal: normal, ortVon: ortVon, vonParameter: vonParameter, ausgangsseite: ausgangsseite, nameVon: nameVon, verborgen: verborgen };

  // Node (Tests): nur hier gibt es module.exports, im Browser nie
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    if (typeof module === 'object' && module && module.exports) module.exports = logik;
    return;
  }

  // ===========================================================================================
  // Teil 2: Browser
  // ===========================================================================================

  var MV = window.__mvSortiment = window.__mvSortiment || {};
  if (MV.a8) return;

  function zeigeEl(el, an) {
    if (!el) return;
    if (an && el.hasAttribute('hidden')) el.removeAttribute('hidden');
    if (!an && !el.hasAttribute('hidden')) el.setAttribute('hidden', '');
  }

  function lesenGemerkt() {
    try {
      return window.sessionStorage.getItem(SPEICHER) || '';
    } catch (e) {
      return '';
    }
  }

  function merken(ort) {
    try {
      if (window.sessionStorage.getItem(SPEICHER) !== ort) window.sessionStorage.setItem(SPEICHER, ort);
    } catch (e) {
      /* ohne Speicher gilt der Link nur fuer diesen Besuch */
    }
  }

  /** Verzeichnis der Seite: Vorlagen von Paket A-3 und Karten des Rasters (Name und Ziel ohne Anker). */
  function verzeichnisVon(w) {
    var genau = [];
    var praefixe = [];
    var ohneAnker = function (u) { return String(u || '').split('#')[0]; };
    var t = w.querySelectorAll('template[data-mv-kontoseite-werkzeug]');
    for (var i = 0; i < t.length; i++) genau.push({ pfad: ohneAnker(t[i].getAttribute('data-mv-kontoseite-url')), name: t[i].getAttribute('data-mv-kontoseite-name') || '' });
    var p = w.querySelectorAll('template[data-mv-kontoseite-praefix]');
    for (var j = 0; j < p.length; j++) praefixe.push({ pfad: ohneAnker(p[j].getAttribute('data-mv-kontoseite-url')), name: p[j].getAttribute('data-mv-kontoseite-name') || '' });
    var k = w.querySelectorAll('[data-mv-a8-werkzeug]');
    for (var m = 0; m < k.length; m++) {
      var a = k[m].querySelector('a[href]');
      var n = k[m].getAttribute('data-mv-a8-name') || '';
      if (a && n && /^\/pages\//.test(a.getAttribute('href') || '')) genau.push({ pfad: ohneAnker(a.getAttribute('href')), name: n });
    }
    return { genau: genau.filter(function (x) { return x.pfad && x.name; }), praefixe: praefixe.filter(function (x) { return x.pfad && x.name; }) };
  }

  function rueckweg(w) {
    var leiste = w.querySelector('[data-mv-a8-rueck]');
    if (!leiste) return;
    var link = leiste.querySelector('[data-mv-a8-zurueck]');
    var text = leiste.querySelector('[data-mv-a8-zurueck-text]');
    if (!link || !text) return;
    var aus = ausgangsseite({
      referrer: document.referrer,
      suche: window.location.search,
      gemerkt: lesenGemerkt(),
      herkunft: window.location.origin,
      hier: window.location.pathname
    });
    if (!aus.ort) return;
    if (aus.quelle !== 'gemerkt') merken(aus.ort);
    var name = nameVon(aus.ort, verzeichnisVon(w));
    var vorlage = leiste.querySelector(name ? '[data-mv-a8-vorlage="zurueck"]' : '[data-mv-a8-vorlage="vorherige"]');
    if (!vorlage) return;
    var kopie = vorlage.cloneNode(true);
    var slot = kopie.querySelector('[data-mv-a8-name]');
    if (slot) slot.textContent = name;
    var neu = String(kopie.textContent || '').replace(/\s+/g, ' ').replace(/^ | $/g, '');
    if (!neu) return;
    link.setAttribute('href', aus.ort);
    if (text.textContent !== neu) text.textContent = neu;
    leiste.setAttribute('data-mv-a8-quelle', aus.quelle);
  }

  function raster(w) {
    var band = w.querySelector('[data-mv-a8-werkzeuge]');
    if (!band) return function () {};
    var liste = w.querySelector('[data-mv-kontoseite-liste]');
    var konto = w.querySelector('[data-mv-a8-konto]');
    var titelAlle = band.querySelector('[data-mv-a8-titel="alle"]');
    var titelWeitere = band.querySelector('[data-mv-a8-titel="weitere"]');
    var karten = [];
    var els = band.querySelectorAll('[data-mv-a8-werkzeug]');
    for (var i = 0; i < els.length; i++) karten.push({ el: els[i], schluessel: els[i].getAttribute('data-mv-a8-werkzeug') || '', praefix: els[i].hasAttribute('data-mv-a8-praefix') });

    function aktualisieren() {
      var zustand = w.getAttribute('data-mv-kontoseite-zustand') || '';
      var eintraege = [];
      var li = liste ? liste.querySelectorAll('[data-mv-kontoseite-eintrag]') : [];
      for (var j = 0; j < li.length; j++) eintraege.push(li[j].getAttribute('data-mv-kontoseite-eintrag') || '');
      var aus = verborgen(karten, eintraege, zustand);
      var sichtbar = 0;
      for (var k = 0; k < karten.length; k++) {
        var an = !aus[karten[k].schluessel];
        zeigeEl(karten[k].el, an);
        if (an) sichtbar++;
      }
      zeigeEl(band, sichtbar > 0);
      zeigeEl(titelAlle, zustand !== 'liste');
      zeigeEl(titelWeitere, zustand === 'liste');
      if (zustand === 'gast') zeigeEl(konto, false);
    }

    w.addEventListener('mv-kontoseite:zustand', aktualisieren);
    if (liste && typeof window.MutationObserver === 'function') {
      new window.MutationObserver(aktualisieren).observe(liste, { childList: true });
    }
    aktualisieren();
    return aktualisieren;
  }

  var seiten = [];

  function starten(bereich) {
    var wurzel = bereich && bereich.querySelectorAll ? bereich : document;
    var liste = [];
    if (wurzel.matches && wurzel.matches('[data-mv-kontoseite]')) liste.push(wurzel);
    var gefunden = wurzel.querySelectorAll('[data-mv-kontoseite]');
    for (var i = 0; i < gefunden.length; i++) liste.push(gefunden[i]);
    liste.forEach(function (w) {
      for (var j = 0; j < seiten.length; j++) if (seiten[j].w === w) return;
      if (!w.querySelector('[data-mv-a8-rueck], [data-mv-a8-werkzeuge]')) return;
      rueckweg(w);
      seiten.push({ w: w, aktualisieren: raster(w) });
    });
    return seiten;
  }

  MV.a8 = { version: VERSION, logik: logik, starten: starten, seiten: function () { return seiten.slice(); } };

  document.addEventListener('shopify:section:load', function (e) {
    starten(e.target);
  });

  // Teil des Buendels: erst nach dem ganzen Buendel starten (Mikrotask), vor dem Start der Kontoseite
  function nachBuendel(fn) {
    if (typeof window.Promise !== 'function') fn();
    else window.Promise.resolve().then(function () { fn(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { nachBuendel(starten); });
  else nachBuendel(starten);
})();
